import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Avatar,
  Box,
  Typography,
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Section from '../../../layout/Section';
import Button from '../../../common/inputs/Button';
import { AdminOrgMember } from '../../../../services/api/admin';
import { colors } from '../../../../styles/colors';

interface OrgMembersSectionProps {
  members: AdminOrgMember[];
  onInviteClick: () => void;
  onMemberClick: (userId: string) => void;
}

function formatLastLogin(isoDate: string | null | undefined): string {
  if (!isoDate) return '–';
  return new Date(isoDate).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

const OrgMembersSection: React.FC<OrgMembersSectionProps> = ({ members, onInviteClick, onMemberClick }) => (
  // Ohne Titel: Die Seite heißt schon „Benutzer" (SeitenTitel aus PageTemplate).
  <Section
    actions={
      <Button variant="primary" onClick={onInviteClick}>
        <PersonAddIcon sx={{ mr: 0.5, fontSize: '1rem' }} />
        User einladen
      </Button>
    }
    noPadding
  >
    {members.length === 0 ? (
      <Typography sx={{ p: 3, color: 'text.secondary', textAlign: 'center' }}>
        Dieser Mandant hat noch keine Benutzer.
      </Typography>
    ) : (
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: colors.background.tableHeader }}>
              <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Vorname</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Nachname</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>E-Mail</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Letzter Login</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {members.map((member) => (
                <TableRow
                  key={member.user_id}
                  hover
                  onClick={() => onMemberClick(member.user_id)}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Avatar
                        src={member.picture ?? undefined}
                        alt={member.name}
                        sx={{ width: 28, height: 28, fontSize: '0.75rem' }}
                      >
                        {member.name.charAt(0).toUpperCase()}
                      </Avatar>
                      {member.name}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: 'text.secondary' }}>{member.first_name ?? '–'}</TableCell>
                  <TableCell sx={{ color: 'text.secondary' }}>{member.last_name ?? '–'}</TableCell>
                  <TableCell sx={{ color: 'text.secondary' }}>{member.email}</TableCell>
                  <TableCell sx={{ color: 'text.secondary', fontFamily: 'monospace', fontSize: '0.8rem' }}>
                    {formatLastLogin(member.last_login)}
                  </TableCell>
                </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Section>
);

export default OrgMembersSection;
